
import React from 'react';
import { Button } from '@/components/ui/button';
import { X } from 'lucide-react';
import QRCode from '@/components/QRCode';
import { type Gift, type Brand } from '@/utils/types';

interface MarketQRCodeViewProps {
  selectedGift: Gift;
  brands: Brand[];
  onMarkAsUsed: () => void;
  onBack: () => void;
}

const MarketQRCodeView: React.FC<MarketQRCodeViewProps> = ({ 
  selectedGift, 
  brands, 
  onMarkAsUsed, 
  onBack 
}) => {
  const brand = brands.find(b => b.id === selectedGift.brandId);
  
  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h2 className="text-2xl font-semibold">Redeem GivGo Bucks</h2>
        <Button 
          variant="ghost" 
          size="icon"
          onClick={onBack}
          className="rounded-full"
        >
          <X className="h-4 w-4" />
        </Button>
      </div>
      
      <QRCode 
        brandName={brand ? brand.name : 'Unknown'} 
        amount={selectedGift.amount} 
        onMarkAsUsed={onMarkAsUsed}
        onBack={onBack}
      />
    </div>
  );
};

export default MarketQRCodeView;
